// FileViewerModal.js
import React, { useEffect, useState, useRef } from "react";
import { Modal, Box, Backdrop, CircularProgress } from "@mui/material";
import * as XLSX from 'xlsx';
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { renderAsync } from 'docx-preview';
import { isEmptyDash } from "../../constant";
import AlertComponent from "../alert/alert";
import { onboardingServices } from "../../services/onboardingServices";
import PDFViewer from 'pdf-viewer-reactjs'
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Tooltip from '@mui/material/Tooltip';

import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
const style = {
  position: "absolute",
  top: "380px",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70% !important",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: "11px",
  textAlign: "center",
};
const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const style2 = {
  // maxHeight: "450px",
  overflow: "auto",
};

const ViewModal = ({ fileSrc, isOpen, onClose, fileExtension, isSubmitCondition, fileName, uploadObj, onUploadMedia, fileIndex, acceptAcknowledge ,vendorPartStatus }) => { 
  const [isAccept, setIsAccept] = useState(null);
  const [termsAccepted, setTermsAccepted] = useState({});
  const [xlsxData, setData] = useState(null);
  const viewerRef = useRef(null);
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  const submitForm = (acceptParam) => {
    if (!termsAccepted[uploadObj?.response[fileIndex]?.key]) {
      openAlert(true, "error", "You must accept document completely before proceeding.");
      return;
    }
    setIsAccept(acceptParam);
    acceptAcknowledge(uploadObj, { vendorResponse: false, isAccept: acceptParam, index: fileIndex });
    onCloseModal();
  }


  const onCloseModal = (acceptParam) => {
    setIsAccept(null);
    setData(null);
    onClose();
  }

  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);

  const openRejectModal = () => {
    setIsRejectModalOpen(true);
  };

  const closeRejectModal = () => {
    setIsRejectModalOpen(false);
  };

  const confirmReject = () => {
    setIsAccept(false);
    closeRejectModal();
  };

  const onReject = () => { 
      if (!termsAccepted[uploadObj?.response[fileIndex]?.key]) {
      openAlert(true, "error", "You must reject document completely before proceeding.");
      return;
    }
    openRejectModal();
  };
  // const onReject = (param) => {
  //   setIsAccept(false);
  // }

  const addFile = (e) => {
    e.preventDefault();
    let fileData = e.target.files[0];
    setFiles(fileData);
  };

  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };

  const handleCloseLoader = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertComponent({ ...alertComponent, open: false });
  };

  const uploadFile = (e) => {
    e.preventDefault();
    if (isEmptyDash(files)) {
      openAlert(true, "error", `Please select a file.`);
      return;
    }
    let formData = new FormData();
    formData.append("file", files);
    setIsLoading(true);
    onboardingServices
      .uploadFile(formData)
      .then(function (response) {
        if (response?.data?.success === true) {
          onUploadMedia(response?.data?.data, uploadObj, files, { vendorResponse: true, isAccept, index: fileIndex });
          openAlert(true, "success", `${response?.data?.message}`);
          setFiles(null);
          document.getElementById("checklist-fileInput-reject").value = null;
          onCloseModal();
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };
  useEffect(() => {
    if (fileExtension == "xlsx" || fileExtension == "xls" || fileExtension == "csv") {
      fetch(fileSrc)
        .then((response) => response.arrayBuffer())
        .then((buffer) => {
          const workbook = XLSX.read(buffer, { type: 'array' });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];

          const styles = `
          <style>
            table {
              border-collapse: collapse;
              width: 100%;
            }
            th, td {
              border: 1px solid black;
              padding: 8px;
            }
          </style>`;

          // Add the styles before the table HTML
          const htmlstr = styles + XLSX.utils.sheet_to_html(worksheet);

          setData(htmlstr);
        })
        .catch((err) => console.error('Error fetching or reading file:', err));
    }

    if (fileExtension == "docx" || fileExtension == "doc") {
      fetch(fileSrc)
        .then((response) => response.arrayBuffer())
        .then((buffer) => {
          renderAsync(buffer, viewerRef.current)
            .catch((err) => console.error('Error rendering DOCX file:', err));
        })
        .catch((err) => console.error('Error fetching DOCX file:', err));
    }

  }, [fileSrc]);

  // useEffect(() => {   
  // }, [uploadObj?.response]);
  const downloadFile = () => {
    if (isEmptyDash(fileSrc)) {
      openAlert(true, "error", `Please select a file.`);
      return;
    } else {
      const link = document.createElement('a');
      link.href = fileSrc;
      link.download = fileSrc.split('/').pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  function formatFileName(fileName, maxLength = 30) {
    if (!fileName || typeof fileName !== 'string') {
      return '';
    }
    if (fileName.length <= maxLength) {
      return fileName;
    }
    const startLength = Math.ceil(maxLength / 2);
    const endLength = Math.floor(maxLength / 2) - 3;

    const startText = fileName.substring(0, startLength);
    const endText = fileName.substring(fileName.length - endLength);

    return `${startText}...${endText}`;
  }
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const handleTermsChange = (index, checked) => {

    setTermsAccepted(prevState => ({
      ...prevState,
      [index]: checked,
    }));
  }; 
  return (

    <div>
      <Modal
        open={isOpen}
        onClose={onCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={(fileExtension == "docx" || fileExtension == "doc") ? style2 : {}}
      >
        <Box
          sx={style}
          className="modal_box_description_file_document"
        >
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="exampleModalLabel">
              <Tooltip title={fileName}> {formatFileName(fileName)}</Tooltip>
            </h1>

            <div className="">
              <Tooltip title="Download">  <span onClick={downloadFile} style={{ cursor: "pointer", paddingRight: "10px" }}> <FileDownloadIcon /></span></Tooltip>

              <Tooltip title="Close"><button type="button" className="btn-close" aria-label="Close" fdprocessedid="kum8iho"
                onClick={() => onCloseModal()}  ></button></Tooltip>
            </div>
          </div>
          <div className="modal-bodys">
            <div className="modal_row_body_main_row1">
              <div>
                {(fileExtension == "png" ||
                  fileExtension == "jpg" ||
                  fileExtension == "jpeg") && <div>
                    <img
                      src={fileSrc}
                      alt="File"
                      style={{ maxWidth: "100%", maxHeight: "600px" }}
                    />
                  </div>}

                {(fileExtension == "pdf") &&
                  <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
                    <div>
                      <Viewer fileUrl={fileSrc} plugins={[defaultLayoutPluginInstance]} />
                    </div>
                  </Worker>
                }

                {/* {(fileExtension == "pdf") && <PDFViewer
                document={{
                  url: fileSrc,
                }}
              />} */}


                {(fileExtension == "xlsx" || fileExtension == "xls" || fileExtension == "csv") && <div className="iframe-pdf-view-div">
                  {xlsxData ? (
                    <div dangerouslySetInnerHTML={{ __html: xlsxData }} />
                  ) : (
                    <p>Loading...</p>
                  )}
                </div>}

                {(fileExtension == "docx" || fileExtension == "doc") && <div ref={viewerRef} style={{ border: '1px solid #ccc', padding: '10px' }}>
                  Loading...
                  <br />
                  Please review the downloaded file for further action{(isSubmitCondition == true && isAccept == null) && Array.isArray(uploadObj?.response) && (uploadObj?.response.length > 0 && uploadObj?.response[fileIndex]?.acknowledged === null) && <> (Accept/Reject) </>}.
                </div>}

              </div>

              <div>
                {/* {(isSubmitCondition == true) &&<div className="accept-modal-div">
                <input type="checkbox" onChange={onCheckChange} checked={isAccept} />
                <span className="accept-modal-text">Accept Terms & Conditions</span>
              </div>} */} 

                {(isSubmitCondition === true && Array.isArray(uploadObj?.response) && uploadObj?.response.length > 0 && uploadObj?.response[fileIndex]?.acknowledged === true) && (
                  <>
                    <h4 style={{ marginTop: "19px" }}>Accepted</h4>
                  </>
                )}
                {(isSubmitCondition === true && Array.isArray(uploadObj?.response) && uploadObj?.response.length > 0 && uploadObj?.response[fileIndex]?.acknowledged === false) && (
                  <>
                    <h4 style={{ marginTop: "19px" }}>Rejected</h4>
                  </>
                )}
                {/* {(isSubmitCondition == true && uploadObj?.response[0]?.acknowledged === true) && <>
                  <h4>Rejected </h4>
                </>} */}

                <div className="accept-modal-btn-div d-flex">
                  {/* <button
                  type="button"
                  class="btn clear_btn_status_block_lists"
                  fdprocessedid="wshspp"
                  onClick={() => onClose()}
                >
                  Close
                </button>               */} 
                  {vendorPartStatus !== 'Pending_To_Participate' && (isSubmitCondition == true && isAccept == null) && Array.isArray(uploadObj?.response) && (uploadObj?.response.length > 0 && uploadObj?.response[fileIndex]?.acknowledged === null) && (
                    <div className="accept-modal-div">
                      <input
                        type="checkbox"
                        onChange={(e) => handleTermsChange(uploadObj?.response[fileIndex]?.key, e.target.checked)}
                        checked={termsAccepted[uploadObj?.response[fileIndex]?.key] || false}
                      />
                      <span className="accept-modal-text">I confirm to have read the document completely</span>
                    </div>
                  )}

                  {(isSubmitCondition == true && isAccept == false) && <> <div className="mb-3 upload-sec-files">
                    <input
                      className="form-control form-h choose"
                      type="file"
                      id="checklist-fileInput-reject"
                      multiple={false}
                      onChange={addFile}
                    />
                    <button
                      onClick={uploadFile}
                      className="file-upload-btn"
                      disabled={isLoading}
                    >

                      {isLoading ? "Uploading..." : "Upload"}
                    </button>

                  </div>
                  </>}

                </div>

              </div>

              <div className="view_modal_all_btn_secondary" style={{ float: "right" }}>
                {vendorPartStatus !== 'Pending_To_Participate' && (isSubmitCondition == true && isAccept == null) && Array.isArray(uploadObj?.response) && (uploadObj?.response.length > 0 && uploadObj?.response[fileIndex]?.acknowledged === null) && <> <button
                  type="button"
                  className="btn btn-outline-secondary"
                  fdprocessedid="wshspp"
                  // onClick={() => {
                  //   onReject(false);
                  // }}

                  onClick={onReject}
                >
                  Reject
                </button>
                </>}
                {vendorPartStatus !== 'Pending_To_Participate' && (isSubmitCondition == true && isAccept == null) && Array.isArray(uploadObj?.response) && (uploadObj?.response.length > 0 && uploadObj?.response[fileIndex]?.acknowledged === null) && <>  <button
                  type="button"
                  class="btn btn-success"
                  // style={{height: "37px"}}
                  fdprocessedid="cn5f6"
                  onClick={() => submitForm(true)}
                // disabled={!isAccept}
                >
                  Accept
                </button>
                </>}
              </div>
            </div>
          </div>

        </Box>
      </Modal>


      {/* Custom Backdrop and Modal */}
      {isRejectModalOpen && (
        <Modal
          open={isRejectModalOpen}
          onClose={closeRejectModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style1} className="modal_react_controlpanel_employees">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">Confirm Rejection</h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeRejectModal}
              ></button>
            </div>
            <div class="modal-bodys">
              <p>Are you sure you want to reject this file?</p>
              <div class="clear_btn_status_modified_boq">

                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={closeRejectModal}>
                    Cancel
                  </button>
                  <button type="button" className="btn btn-success" onClick={confirmReject}>
                    Reject
                  </button>
                </div>
              </div>
            </div>
          </Box>
        </Modal>
      )}


      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleCloseLoader}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default ViewModal;
